import type { AdminGoldenAsset, AdminGoldenAssetList, GoldenAssetsQuery } from "@storyline/shared";
import { unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";

export const listAssets = async (seriesId: string, query: GoldenAssetsQuery = {}): Promise<AdminGoldenAssetList> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).assets.get({ query })));

export const approveAsset = async (assetId: string): Promise<AdminGoldenAsset> =>
	unwrap(await request(() => httpClient.admin.assets({ assetId }).approve.post()));

export const lockAsset = async (assetId: string): Promise<AdminGoldenAsset> =>
	unwrap(await request(() => httpClient.admin.assets({ assetId }).lock.post()));

export const unlockAsset = async (assetId: string): Promise<AdminGoldenAsset> =>
	unwrap(await request(() => httpClient.admin.assets({ assetId }).unlock.post()));
